import { MenuItem, Select } from "@mui/material";
import React from "react";

const SelectField = ({
  title,
  form,
  id,
  options,
  onChange,
  clearFields,
  sx,
  disabled,
}) => {
  const localHanlechange = (event) => {
    if (id) {
      if (clearFields) {
        clearFields?.forEach((_id) => {
          form.setFieldValue(_id, "");
        });
      }
      form.setFieldValue(id, event.target.value);
    }
  };

  return (
    <div className="w-full">
      <Select
        size="small"
        disabled={disabled}
        sx={{
          ...sx,
          borderRadius: "8px",
          backgroundColor: "#FFF",
          "& .MuiSelect-nativeInput": {},
          text: "14px",
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#F2F2F7",
              borderRadius: "8px",
              borderWidth: "1.3px",
            },
          },
        }}
        fullWidth
        defaultValue=""
        required
        onChange={onChange ? onChange : localHanlechange}
        value={form?.values[id]}
        displayEmpty
        def
        id={id}
        style={{}}
        inputProps={{ "aria-label": "Without label" }}
        renderValue={
          form?.values[id]
            ? (selected) => (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  className="font-[400] text-[14px] md:text-[16px] text-[#131E3D] capitalize"
                >
                  {selected?.icon && (
                    <img src={selected?.icon} alt="" className="w-4 h-4" />
                  )}
                  {selected?.label}
                </div>
              )
            : null
        }
      >
        <MenuItem
          disabled={true}
          style={{ fontSize: "16px", color: "#131E3D", fontWeight: "400" }}
          value=""
        >
          {title}
        </MenuItem>
        {options?.map((option) => (
          <MenuItem
            key={option.value}
            value={option}
            style={{ fontSize: "16px", color: "#131E3D", fontWeight: "400" }}
            classes={{ selected: "selected-option" }}
          >
            {option.icon && (
              <img src={option.icon} alt="" className="w-4 h-4 mr-2" />
            )}
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {form?.errors[id] ? (
        <h6 className=" text-[0.75rem] mt-[6px] mb-2 text-[#ef5364] text-left w-full">
          {form?.errors[id]}
        </h6>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SelectField;
